<template>
  <div></div>
</template>
<script>
export default {
  mounted() {
    // if we got to this page then send over to the default page: forms
    this.$router.push("/forms");
  },
};
</script>
